export const LIGHT_BLUR_RADIUS = 12;
export const BLUR_RADIUS = 24;
